var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#21252C;stroke-width:50;stroke-miterlimit:133.3333;}\r\n\t.st1{fill:#21252C;}\r\n\t.st2{fill:none;stroke:#21252C;stroke-width:50;stroke-linecap:round;stroke-miterlimit:133.3333;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.3,200v433.3c0,55.2,44.8,100,100,100h333.3c55.2,0,100-44.8,100-100V300c0-55.2-44.8-100-100-100H133.3z  M133.3,200v-33.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600,200v25h25v-25H600z M523.9,77.5l-3.5-24.7L523.9,77.5z M164,129l-3.5-24.7l0,0L164,129z M169,225h431v-50 H169V225z M625,200v-56.5h-50V200H625z M520.4,52.8l-359.9,51.4l7.1,49.5l359.9-51.4L520.4,52.8z M160.5,104.2 c-29.9,4.3-52.1,29.9-52.1,60.1h50c0-5.3,3.9-9.8,9.2-10.6L160.5,104.2z M625,143.5c0-55.8-49.4-98.6-104.6-90.7l7.1,49.5 c25.1-3.6,47.6,15.9,47.6,41.2H625z M169,175c-5.9,0-10.7-4.8-10.7-10.7h-50c0,33.5,27.2,60.7,60.7,60.7V175z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.7,400h266.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.7,516.7H450"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.128b320cc74e8e35e9ae695e6c76b592.svg";
export { ForwardRef as ReactComponent };